import { CommonApi } from "@/zh-website/src/views/Enterprise/api/index";
import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";

export class CommonService extends BaseAbstractService {
  static getAllClassification(query) {
    return CommonApi.getAllClassification(this.request, query);
  }
  static getSolutionDetail(query) {
    return CommonApi.getSolutionDetail(this.request, query);
  }
  static getSuccessCasesList(query) {
    return CommonApi.getSuccessCasesList(this.request, query);
  }
  static getSuccessCasesGroupedList(query) {
    return CommonApi.getSuccessCasesGroupedList(this.request, query);
  }
  static getSuccessCasesDetail(query) {
    return CommonApi.getSuccessCasesDetail(this.request, query);
  }
  static getCustomDetail(query) {
    return CommonApi.getCustomDetail(this.request, query);
  }
}
CommonService.setRequest(RequestService);
